import { Beneficiaries } from '../../../../banking/components/beneficiaries/Beneficiaries';

export default function BeneficiariesPage() {
    return <Beneficiaries />;
}
